module.exports = __webpack_public_path__ + "img/mir-card-pay.ef81273f.svg";